var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCode = function SvgIconCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.94 4.092a1 1 0 0 0-1.88-.684l-6 16.5a1 1 0 1 0 1.88.684zM6.768 7.61a1 1 0 0 1-.128 1.408L3.062 12l3.578 2.982a1 1 0 1 1-1.28 1.536l-4.5-3.75a1 1 0 0 1 0-1.536l4.5-3.75a1 1 0 0 1 1.408.128M17.232 7.61a1 1 0 0 1 1.408-.128l4.5 3.75a1 1 0 0 1 0 1.536l-4.5 3.75a1 1 0 1 1-1.28-1.536L20.938 12 17.36 9.018a1 1 0 0 1-.128-1.408"
  }))));
};
export default SvgIconCode;